import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_313_651)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7.50001 9.5C8.60458 9.5 9.50001 8.60457 9.50001 7.5C9.50001 6.39543 8.60458 5.5 7.50001 5.5C6.39544 5.5 5.50001 6.39543 5.50001 7.5C5.50001 8.60457 6.39544 9.5 7.50001 9.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.6563 7.5C12.6563 7.37314 12.6511 7.24764 12.6413 7.12349C12.5999 6.59804 12.8106 6.06419 13.2675 5.80149C13.8328 5.47651 14.0263 4.75401 13.6992 4.18995L13.4777 3.80791C13.1505 3.24379 12.4288 3.05047 11.8634 3.37552C11.4058 3.63863 10.8366 3.55456 10.3995 3.25854C10.1898 3.11645 9.96888 2.98946 9.73839 2.87902C9.26356 2.65149 8.90625 2.20165 8.90625 1.67512C8.90625 1.02612 8.38014 0.5 7.73114 0.5H7.26904C6.61995 0.5 6.09375 1.02619 6.09375 1.67529C6.09375 2.20132 5.7372 2.65092 5.26291 2.87844C5.032 2.98921 4.81062 3.11654 4.60034 3.25901C4.16348 3.555 3.59439 3.63875 3.13693 3.37572C2.5714 3.05056 1.84941 3.24395 1.52214 3.80826L1.30078 4.18995C0.973659 4.75401 1.16721 5.47651 1.7325 5.80149C2.18946 6.06419 2.40008 6.59804 2.35866 7.12349C2.34888 7.24764 2.34375 7.37314 2.34375 7.5C2.34375 7.62672 2.34889 7.75224 2.3587 7.8765C2.40016 8.40195 2.18946 8.93581 1.7325 9.19851C1.16721 9.52349 0.973659 10.246 1.30078 10.81L1.52211 11.1917C1.84942 11.7561 2.57145 11.9496 3.13711 11.6245C3.59496 11.3614 4.16445 11.4455 4.60168 11.7417C4.81137 11.8837 5.03217 12.0106 5.26255 12.121C5.73739 12.3485 6.09469 12.7983 6.09469 13.3249C6.09469 13.9739 6.62081 14.5 7.26981 14.5H7.73206C8.38107 14.5 8.90719 13.9739 8.90719 13.3249C8.90719 12.7988 9.26388 12.3492 9.73825 12.1217C9.96907 12.011 10.1903 11.8838 10.4004 11.7415C10.8374 11.4456 11.4065 11.362 11.8641 11.625C12.4301 11.9503 13.1527 11.7567 13.4802 11.1919L13.6998 10.8132C14.0276 10.2479 13.8337 9.52385 13.2671 9.19815C12.811 8.93594 12.5996 8.40411 12.6411 7.87966C12.651 7.75436 12.6563 7.62779 12.6563 7.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_313_651",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor"
		})
	}) })]
});
export default SvgIconCog;
